import React from 'react';
import { exportToExcel } from './exportToExcel';
import { ReactComponent as ExcelIcon } from "../../../../../../../../assets/img/svg/excel.svg";
import { ReactComponent as DownloadIcon } from "../../../../../../../../assets/img/svg/downloadBlackV2.svg";
import { getFormattedDate } from '../../../../../edpOps/constant/batch-search';

const headers = [
    { label: 'Type', key: 'type' },
    { label: 'Item Type', key: 'itemType' },
    { label: 'Description', key: 'description' },
    { label: 'Due Date', key: 'dueDate' },
    { label: 'Gross Amount', key: 'totalGrossAmount' },
    { label: 'Concession', key: 'totalConcessionApplied' },
    { label: 'Net Payable', key: 'totalNetPayableWithoutTaxAmount' },
    { label: 'Tax', key: 'taxAmount' },
    { label: 'Net Payable (Inc Taxes) - (A)', key: 'totalNetPayableAmount' },
    { label: 'Total Paid inc. PDCs (Inc. Taxes) - (B)', key: 'totalPaidAmount' },
    { label: 'Total Outstanding (A-B)', key: 'totalBalanceAmount' },
    { label: 'Total Paid Realized only (Inc. Taxes) (C)', key: 'totalPaidRealizedOnly' },
    { label: 'Outstanding based on Realized (A-C)', key: 'totalOutstandingRealizedBased' },
    { label: 'Status', key: 'status' },
]

const TOTALS_FIELDS = {
    totalGrossAmount: 0,
    totalConcessionApplied: 0,
    totalNetPayableWithoutTaxAmount: 0,
    taxes: 0,
    totalNetPayableAmount: 0,
    totalPaidAmount: 0,
    totalBalanceAmount: 0,
    totalPaidRealizedOnly: 0,
    totalOutstandingRealizedBased: 0,
}

const DownloadExcel = ({
    studentChargesListFiltered = [],
    fileName = () => {}
}) => {


    const otherChargesTotal = { description: 'Other Charges Total', ...TOTALS_FIELDS };
    const regularChargesTotal = { description: 'Regular Charges Total', ...TOTALS_FIELDS };
    const grandTotal = { description: 'Grand Total', ...TOTALS_FIELDS };

    const formatPaymentStatus = status => status === "UNPAID" ? "NOT PAID" : status;

    const addToTotal = (itemType, totalObj) => {

        Object.keys(TOTALS_FIELDS).forEach(totalField => {
            totalObj[totalField] += itemType[totalField];
            grandTotal[totalField] += itemType[totalField];
        })

    }

    const convertToExcelData = (charges = [], type, totalObj) => {

        return charges.flatMap(el => {

            if (!!el?.itemTypeWiseInstallmentsList) {

                const installmentList = el.itemTypeWiseInstallmentsList.map(itemType => {
                    addToTotal(itemType, totalObj);
                    return {
                        ...itemType,
                        type,
                        dueDate: getFormattedDate(itemType?.dueDate),
                        status: formatPaymentStatus(el?.status)
                    }
                });

                return installmentList;
            }
            else {
                addToTotal(el, totalObj);
                return {
                    ...el,
                    type,
                    dueDate: getFormattedDate(el?.dueDate),
                    status: formatPaymentStatus(el?.status)
                }
            }
        }
        );

    }

    const otherCharges = studentChargesListFiltered["OTHER_CHARGES"] || [];
    const regularCharges = studentChargesListFiltered["REGULAR_CHARGES"] || [];

    const otherChargesData = convertToExcelData(
        otherCharges,
        'Other Charges',
        otherChargesTotal
    );

    const regularChargesData = convertToExcelData(
        regularCharges,
        'Regular Charges',
        regularChargesTotal
    );



    const excelData = [
        ...otherChargesData,
        ...regularChargesData,
        ...(otherCharges?.length > 0 ? [otherChargesTotal] : []),
        ...(regularCharges?.length > 0 ? [regularChargesTotal] : []),
        grandTotal
    ];


    return (
        <div>
            <ExcelIcon className='icon mr-2'/>
            <span className='file-name'>{fileName()}</span>
            <span>.xlsx</span>
            <DownloadIcon className='icon ml-2 cursor' onClick={() =>  exportToExcel(excelData, headers, fileName())}/>
        </div>
    );

}

export default DownloadExcel;